import tracker, { allTrackers, allErrorTrackers } from '@cx/analytics'

export default tracker(allTrackers, allErrorTrackers)
